import { Injectable } from '@angular/core';

import { ModalDialogService } from '../../_shared/services/modal-dialog.service';
import { UtilService } from '../../_shared/services/util.service';

import { Currency } from './currency.model';
import { CurrencyModalComponent } from '../components/currency-modal/currency-modal.component';
import { CurrencyTranslationModalComponent } from '../components/currency-translation-modal/currency-translation-modal.component';

@Injectable({
  providedIn: 'root',
})
export class CurrencyModalService {
  constructor(private modalDialogService: ModalDialogService, private utilService: UtilService) {}

  openCurrencyModal(
    currency: Currency,
    defaultLanguage,
    additionalLanguages,
    mode,
    successCallback = null
  ) {
    const confirmCallback = (result) => {
      // Edit
      if (currency.id) {
        currency.name = result.name;
        currency.code = result.code;
        currency.symbol = result.symbol;
        currency.decimal_places = result.decimal_places;
        // currency.allow_automatic_exchange_rate = result.allow_automatic_exchange_rate;
        currency.enable_automatic_exchange_rate = result.enable_automatic_exchange_rate;

        return this.utilService.changeItemRowStyle(currency.id);
      }

      return successCallback(result);
    };

    const options = {
      disableClose: true,
      data: {
        title: 'CURRENCY_DETAILS',
        obj: currency,
        params: {
          defaultLanguage: defaultLanguage,
          additionalLanguages: additionalLanguages,
          mode: mode,
        },
      },
      confirmCallback: confirmCallback,
    };

    this.modalDialogService.open(options, CurrencyModalComponent);
  }

  openCurrencyTranslation(currency: Currency, language: any) {
    const options = {
      panelClass: 'dialog-sidepanel',
      position: { right: '0' },
      data: {
        title: 'CURRENCY_DETAILS',
        obj: currency,
        params: {
          language: language,
        },
      },
    };

    this.modalDialogService.open(options, CurrencyTranslationModalComponent);
  }
}
